export default __webpack_public_path__ + "static/media/banners_posthotsale_moto_330x330.b309d36b.jpg";